module.exports = "<div class=\"mat-app-background\">\n  <app-dashboard></app-dashboard>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/thechairman/Documents/projects/web-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main